import React from "react";
import Navbar from "../components/universal/navbar";
import Footer from "../components/universal/footer";
import Header from "../components/fee/feepageHero";
import { Helmet } from "react-helmet";
const Thankyou = () => {
  return (
    <>
      <Helmet>
        <title>Thank You | Regent Dental</title>
        <meta
          name="description"
          content="Ensure a clear understanding of our policies and your rights as a patient."
        />
        <link rel="canonical" href="https://www.regent-dental.co.uk" />
      </Helmet>
      <Navbar />
      <Header heading />
      <Footer />
    </>
  );
};

export default Thankyou;
